import { render, staticRenderFns } from "./QnCenter.vue?vue&type=template&id=5eb9f8fd&scoped=true&"
import script from "./QnCenter.vue?vue&type=script&lang=js&"
export * from "./QnCenter.vue?vue&type=script&lang=js&"
import style0 from "./QnCenter.vue?vue&type=style&index=0&id=5eb9f8fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9f8fd",
  null
  
)

export default component.exports